/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { InternalValidationAuthorType } from './';
import {
    InternalValidationAuthorTypeFromJSON,
    InternalValidationAuthorTypeFromJSONTyped,
    InternalValidationAuthorTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComplianceAdminDocumentResource
 */
export interface ComplianceAdminDocumentResource {
    /**
     * Array of compliance file IDs for the latest uploaded document
     * @type {Array<string>}
     * @memberof ComplianceAdminDocumentResource
     */
    complianceFileIds: Array<string>;
    /**
     * Array of file names for the latest uploaded document
     * @type {Array<string>}
     * @memberof ComplianceAdminDocumentResource
     */
    fileNames: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof ComplianceAdminDocumentResource
     */
    uploadDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ComplianceAdminDocumentResource
     */
    legalEmissionDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ComplianceAdminDocumentResource
     */
    legalValidityDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ComplianceAdminDocumentResource
     */
    statusMessage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComplianceAdminDocumentResource
     */
    downloadLinks: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ComplianceAdminDocumentResource
     */
    lastInternalValidationAuthorName?: string;
    /**
     * 
     * @type {InternalValidationAuthorType}
     * @memberof ComplianceAdminDocumentResource
     */
    lastInternalValidationAuthorType?: InternalValidationAuthorType;
    /**
     * 
     * @type {Date}
     * @memberof ComplianceAdminDocumentResource
     */
    lastInternalValidationDate?: Date;
    /**
     * Whether the document is still available on our storage.
     * @type {boolean}
     * @memberof ComplianceAdminDocumentResource
     */
    isStillAvailable: boolean;
}

/**
 * Check if a given object implements the ComplianceAdminDocumentResource interface.
 */
export function instanceOfComplianceAdminDocumentResource(value: object): value is ComplianceAdminDocumentResource {
    if (!('complianceFileIds' in value) || value['complianceFileIds'] === undefined) return false;
    if (!('fileNames' in value) || value['fileNames'] === undefined) return false;
    if (!('uploadDate' in value) || value['uploadDate'] === undefined) return false;
    if (!('statusMessage' in value) || value['statusMessage'] === undefined) return false;
    if (!('downloadLinks' in value) || value['downloadLinks'] === undefined) return false;
    if (!('isStillAvailable' in value) || value['isStillAvailable'] === undefined) return false;
    return true;
}

export function ComplianceAdminDocumentResourceFromJSON(json: any): ComplianceAdminDocumentResource {
    return ComplianceAdminDocumentResourceFromJSONTyped(json, false);
}

export function ComplianceAdminDocumentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceAdminDocumentResource {
    if (json == null) {
        return json;
    }
    return {
        
        'complianceFileIds': json['complianceFileIds'],
        'fileNames': json['fileNames'],
        'uploadDate': (new Date(json['uploadDate'])),
        'legalEmissionDate': json['legalEmissionDate'] == null ? undefined : (new Date(json['legalEmissionDate'])),
        'legalValidityDate': json['legalValidityDate'] == null ? undefined : (new Date(json['legalValidityDate'])),
        'statusMessage': json['statusMessage'],
        'downloadLinks': json['downloadLinks'],
        'lastInternalValidationAuthorName': json['lastInternalValidationAuthorName'] == null ? undefined : json['lastInternalValidationAuthorName'],
        'lastInternalValidationAuthorType': json['lastInternalValidationAuthorType'] == null ? undefined : InternalValidationAuthorTypeFromJSON(json['lastInternalValidationAuthorType']),
        'lastInternalValidationDate': json['lastInternalValidationDate'] == null ? undefined : (new Date(json['lastInternalValidationDate'])),
        'isStillAvailable': json['isStillAvailable'],
    };
}

export function ComplianceAdminDocumentResourceToJSON(value?: ComplianceAdminDocumentResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'complianceFileIds': value['complianceFileIds'],
        'fileNames': value['fileNames'],
        'uploadDate': ((value['uploadDate']).toISOString()),
        'legalEmissionDate': value['legalEmissionDate'] == null ? undefined : ((value['legalEmissionDate']).toISOString()),
        'legalValidityDate': value['legalValidityDate'] == null ? undefined : ((value['legalValidityDate']).toISOString()),
        'statusMessage': value['statusMessage'],
        'downloadLinks': value['downloadLinks'],
        'lastInternalValidationAuthorName': value['lastInternalValidationAuthorName'],
        'lastInternalValidationAuthorType': InternalValidationAuthorTypeToJSON(value['lastInternalValidationAuthorType']),
        'lastInternalValidationDate': value['lastInternalValidationDate'] == null ? undefined : ((value['lastInternalValidationDate']).toISOString()),
        'isStillAvailable': value['isStillAvailable'],
    };
}

